var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { defaultTimeSelectProps } from './defaults';
import { UlTag, LiTag, DivTag, SpanTag } from '../../Utils/AtomicTag';
import { scrollTo } from '../../Utils/browser';
import { TIMETYPE } from './utils';
var TimeSelect = /** @class */ (function (_super) {
    __extends(TimeSelect, _super);
    function TimeSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.scrollTime = function (distance) {
            setTimeout(function () {
                if (_this.container)
                    scrollTo(0, distance, { duration: 0 }, function () { }, _this.container);
            });
        };
        _this.state = {
            activeIdx: 0,
        };
        return _this;
    }
    TimeSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, type = _a.type, options = _a.options, value = _a.value, onSelectTime = _a.onSelectTime, panel = _a.panel;
        var DivCls = ['w-4/12', 'relative'];
        var contextUlCls = ['border-r', 'overflow-y-scroll', 'h-full'];
        var contextLiCls = ['w-full', 'h-7', 'leading-8', 'cursor-pointer'];
        var contextLiSelectedCls = ['text-brand-600', 'font-medium'];
        var typeCls = [
            'absolute',
            'top-0',
            'right-0',
            'w-full',
            'pl-px-32',
            'text-brand-600',
            'h-7',
            'leading-8',
            'cursor-pointer',
            'font-medium',
        ];
        var contextSpanCls = ['pl-px-14'];
        return (React.createElement(DivTag, { atomics: DivCls, name: TimeSelect.NAME, autoPrefixedClassName: "time-picker-combobox-select" },
            React.createElement(UlTag, { atomics: contextUlCls, ref: function (container) { return (_this.container = container); }, className: 'contextUl' }, options.map(function (time, i) {
                if (time.value == value)
                    _this.scrollTime(i * 28);
                return (React.createElement(LiTag, { atomics: time.value == value ? contextLiCls.concat(contextLiSelectedCls) : contextLiCls, key: i, onClick: function (e) { return onSelectTime(e, type, time, i, _this.container); } },
                    React.createElement(SpanTag, { atomics: contextSpanCls }, time.value < 10 ? "0" + time.value : time.value)));
            })),
            panel == 'default' && React.createElement(DivTag, { atomics: typeCls }, TIMETYPE[type])));
    };
    TimeSelect.defaultProps = defaultTimeSelectProps;
    TimeSelect.NAME = 'time-select';
    return TimeSelect;
}(React.Component));
export default TimeSelect;
